export default __webpack_public_path__ + "static/media/674.191da746.png";